import { type } from 'arktype';
import { baseJunctionQuerySchema, baseJunctionCreateSchema } from './shared';

/**
 * Query schema for filtering calendar-person associations
 */
export const calendarPersonQuerySchema = baseJunctionQuerySchema
  .and(
    type({
      'personId?': type('string').configure({
        description: 'Filter associations by the linked person ID.',
        examples: ['per_018ef4a2'],
      }),
    })
  )
  .configure({ description: 'Query parameters for listing calendar-to-person associations.' });
export type CalendarPersonQuery = typeof calendarPersonQuerySchema.t;

/**
 * Schema for creating a calendar-person association
 */
export const createCalendarPersonSchema = baseJunctionCreateSchema
  .and(
    type({
      personId: type('string').configure({
        description: 'ID of the person the individual calendar is being associated with.',
        examples: ['per_018ef4a2'],
      }),
    })
  )
  .configure({ description: 'Payload for linking an individual calendar to a person.' });
export type CreateCalendarPerson = typeof createCalendarPersonSchema.t;

export const calendarPersonSchema = type({
  id: type('string').configure({
    description: 'Assignment id. Pass it as `assignmentId` to `DELETE /calendar/calendars/{calendarId}/persons/{assignmentId}`.',
  }),
  calendarId: 'string',
  personId: 'string',
  createdAt: 'string',
  updatedAt: 'string',
}).configure({ description: 'Calendar-to-person association.' });
export type CalendarPerson = typeof calendarPersonSchema.infer;
